import React from 'react';
// import { OrdersPageTabs } from '@pages/orders/orderItem/OrderItem';

import NotificationItem from './_notificationItem';
import { NotificationCustomerWithVendor } from '@models/notifications.model';

interface Props {
  notification: NotificationCustomerWithVendor;
  onNavigate: () => void;
}

const NotificationCustomerRefundRequest: React.FC<Props> = ({ notification }) => {
  const CSSBlock = 'notification-refund-request';

  const onClickView = () => {
    // navigateTransitioned({
    //   dispatch,
    //   navigate,
    //   to: routingPaths[RoutingViews.ORDERS_ALL],
    //   search: {
    //     [SearchParams.ORDER_ID]: notification.orderDocID!,
    //     [SearchParams.ACTIVE_TAB]: OrdersPageTabs.REFUND_STATUS,
    //   },
    // });
    // onNavigate();
  };

  return (
    <NotificationItem
      notification={notification}
      CSSBlock={CSSBlock}
      buttonText="View"
      buttonOnClick={onClickView}></NotificationItem>
  );
};

export default NotificationCustomerRefundRequest;
